import { render } from "./application_overview_details.html?vue&type=template&id=196f7936&external"
import script from "./application_overview_details.js?vue&type=script&lang=js&external"
export * from "./application_overview_details.js?vue&type=script&lang=js&external"

import "./ApplicationOverviewDetails.vue?vue&type=style&index=0&id=196f7936&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__